import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import MobileInput from "../componets/MobileInput";
import "./inquiry.css";

const Inquiry = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current pathname

  const [formData, setFormData] = useState({
    fullName: "",
    address: "",
    phoneNumber: "",
    email: "",
    countryCode: "",
  });

  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const countryCodes = {
    in: "1",
    gb: "2",
    us: "3",
    au: "4",
    ca: "5",
    ae: "6",
    sg: "7",
    tz: "8",
    ke: "9",
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneNumberChange = (newValue, country) => {
    const selectedCountryCode = countryCodes[country?.countryCode];
    const dialCode = country?.dialCode;
    const phoneWithoutCountryCode = newValue.startsWith(dialCode)
      ? newValue.slice(dialCode.length)
      : newValue;

    setFormData({
      ...formData,
      phoneNumber: phoneWithoutCountryCode,
      countryCode: selectedCountryCode,
    });
  };

  const handleOtpVerified = (otp) => {
    console.log("OTP Verified:", otp);
    setOtp(otp);
    setIsOtpVerified(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullName, address, phoneNumber, email, countryCode } = formData;

    if (!fullName || !phoneNumber || !isOtpVerified) {
      Swal.fire({
        title: "Error",
        html: "<p style='font-weight: bold;'>Please complete all fields and verify OTP before submitting.</p>",
        icon: "error",
        scrollbarPadding: false,
      });
      return;
    }

    const offerValue =
      location.pathname === "/inquiry"
        ? "2"
        : location.pathname === "/inquiry-now"
        ? "1"
        : "";

    const data = {
      Phone: phoneNumber,
      Country: countryCode,
      OTP: otp,
      Name: fullName,
      Email: email,
      Address: address,
      Offer: offerValue,
    };

    setSubmitLoading(true);

    try {
      const response = await fetch(
        "https://erp.radiantsunenergy.com/api/addInquiry",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: "Successfully Submitted!",
          html: "<p style='font-weight: bold;'>Your inquiry has been submitted successfully!</p>",
          icon: "success",
          scrollbarPadding: false,
        }).then(() => navigate("/products"));
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to submit inquiry. Please try again.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const isFormValid =
    formData.fullName && formData.phoneNumber && isOtpVerified;

  return (
    <div className="py-5 main-container">
      <div className="container-fluid inquiry-form p-4">
        <h2 className="text-center fw-bold fs-1">Inquiry Form</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-1">
            <label className="form-label fs-5 fw-semibold">Mobile Number</label>
            <MobileInput
              className="form-control fs-6 p-4 fw-semibold"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Enter mobile number"
              phoneNumber={formData.phoneNumber}
              countryCode={formData.countryCode}
              onChange={handlePhoneNumberChange}
              onOtpVerified={handleOtpVerified}
              defaultCountry="in"
            />
          </div>

          <div className="mb-1">
            <label htmlFor="fullName" className="form-label fs-5 fw-semibold">
              Full Name
            </label>
            <input
              type="text"
              className="form-control fs-6 fw-semibold"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
            />
          </div>

          <div className="mb-1">
            <label htmlFor="email" className="form-label fs-5 fw-semibold">
              Email
            </label>
            <input
              type="email"
              className="form-control fs-6 fw-semibold"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className="mb-1">
            <label htmlFor="address" className="form-label fs-5 fw-semibold">
              Address
            </label>
            <input
              type="text"
              className="form-control fs-6 fw-semibold"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>

          <button
            type="submit"
            className="btn submit-btn d-inline d-md-block mt-3"
            disabled={!isFormValid || submitLoading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              opacity: submitLoading ? 0.8 : 1,
              cursor: submitLoading ? "not-allowed" : "pointer",
            }}
          >
            {submitLoading ? (
              <div
                className="spinner-border spinner-border-sm text-light"
                role="status"
                style={{ width: "1rem", height: "1rem" }}
              />
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Inquiry;
